module.exports = __webpack_public_path__ + "img/elementwidths_jak.edf401c4.png";